module.exports = __webpack_public_path__ + "static/media/company.b2caaf90.jpeg";